module.exports = __webpack_public_path__ + "img/undraw_celebration_0jvk.21b8d87b.svg";